<div class="backdrop" (click)="closeDialogAndDeleteChanges.emit(noteValueBeforeChanges)"></div>
<div class="dialog-wrapper">
  <div [formGroup]="formGroup" class="dialog">
    <div class="box">
      <div class="title">הוסף הערה</div>
      <textarea appCurserSideByLanguaga rows="4" formControlName="note" [value]="formGroup.controls.note.value"></textarea>
      <div (click)="closeDialog.emit()" class="button">שמור הערה</div>
    </div>
  </div>
</div>